<template>
    <el-dialog
        top="5vh"
        width="800px"
        title="绩效审批"
        :visible.sync="visible"
        class="legal-perform-audit-dialog"
        :before-close="close">
        <el-button type="primary" :loading="btnLoading" @click="handleSubmit">提交</el-button>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item prop="result" class="audit-radio-form-item">
                <el-radio v-model="ruleForm.result" label="1">审批通过</el-radio>
                <el-radio v-model="ruleForm.result" label="0">驳回</el-radio>
            </el-form-item>
            <el-form-item prop="reason" v-if="ruleForm.result === '0'">
                <el-input
                    v-model="ruleForm.reason"
                    type="textarea"
                    :rows="5"
                    maxlength="250"
                    show-word-limit
                    placeholder="请输入驳回原因"></el-input>
            </el-form-item>
        </el-form>
        <div class="adjust-message">
            <span>业务类型：{{ businessTypeObj[businessType] }}</span>
            <span>供应商名称：{{ supplierName }}</span>
            <span>调整月份：{{ month }}</span>
            <span>
                月度绩效得分：
                <span :class="+score < 90 ? 'red-score' : 'green-score'">{{ score }}</span>
            </span>
            <span>月度绩效目标得分：≥90</span>
        </div>
        <indicatorTable ref="indicatorTable" />
        <div class="sub-title">操作记录</div>
        <OperateRecordList ref="orlRef" />
    </el-dialog>
</template>
<script>
import { TRANSPORTATION_NUM, DELIVERY_NUM } from '../../../../constant/constant.js'
import OperateRecordList from '../../components/OperateRecordList.vue'
import indicatorTable from '../../components/indicatorTable.vue'
import {
    selectSupplierPerformanceConfigurationAdjustDetail,
    updateSupplierLegalPersonPerformanceStatus,
} from '../../../../api/performManage.js'
import { ACTION_TYPE } from '../../constant.js'

export default {
    components: { OperateRecordList, indicatorTable },
    data() {
        return {
            btnLoading: false,
            visible: false,
            businessType: '',
            supplierName: '',
            month: '',
            score: '',
            rules: {
                result: [{ required: true, message: '请选择审批结果', trigger: 'change' }],
                reason: [
                    { required: true, message: '请输入驳回原因', trigger: 'blur' },
                    { max: 250, message: '不能超过250个字符', trigger: 'blur' },
                ],
            },
            ruleForm: {
                result: null,
                reason: null,
            },
            businessTypeObj: {
                [TRANSPORTATION_NUM]: '运输',
                [DELIVERY_NUM]: '配送',
                ['5']: '配送(新)',
            },
            id: '',
        }
    },
    methods: {
        open(data) {
            this.visible = true
            this.loadData(data.id)
            this.id = data.id
            this.$nextTick(() => {
                this.$refs.orlRef.init(data)
            })
        },
        loadData(id) {
            selectSupplierPerformanceConfigurationAdjustDetail({ id,operativeFunction: ACTION_TYPE.APPROVE_PASS })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.businessType = res.data.businessType
                        this.supplierName = res.data.supplierNameCn
                        this.month = res.data.month
                        this.score = res.data.countScore
                        this.$refs['indicatorTable'].init(res.data.detailList)
                    }
                })
        },
        close() {
            this.$refs['indicatorTable'].reset()
            this.$refs.orlRef.reset()
            this.$refs.ruleForm.resetFields()
            this.visible = false
        },
        handleSubmit() {
            this.$refs.ruleForm.validate().then(valid => {
                if (valid) {
                    this.btnLoading = true
                    updateSupplierLegalPersonPerformanceStatus({
                        ids: [this.id],
                        operativeFunction:
                            this.ruleForm.result === '0' ? ACTION_TYPE.APPROVE_REJECT : ACTION_TYPE.APPROVE_PASS,
                        operativeFunctionReason: this.ruleForm.result === '0' ? this.ruleForm.reason : '',
                    })
                        .then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success(`${this.ruleForm.result === '0'?'驳回':'审批'}成功`)
                                this.$emit('refresh')
                                this.close()
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false
                        })
                }
            })
        },
    },
}
</script>
<style lang="less">
.legal-perform-audit-dialog {
    .adjust-message {
        margin-bottom: 10px;

        & > span {
            display: inline-block;
            margin-right: 20px;
        }
    }

    .sub-title {
        margin: 20px 0 10px;
        font-size: 16px;
    }

    .el-form {
        margin: 15px 0 25px;
    }

    .audit-radio-form-item .el-form-item__content {
        line-height: 1.2em;
    }
}
</style>
